import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import FollowupHeader from './followupHeader';
import FollowupDetails from './followupDetails';
import useFollowupInvestigation from './useFollowupInvestigation';

// Followup item component - styled to match CheckItem
const FollowupCard = ({
  followupId,
  followup,
  content: _content = null,
  path,
  formActions,
  reduxEntity,
  pendingOperation: _pendingOperation = false,
  notificationActions
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isRunning, setIsRunning] = useState(false);
  const hasAnalysis = !!followup.analysis;
  // Always expandable - either for reasoning, analysis results, or Run Analysis button
  const hasDetails = true;

  // Use custom hook for investigation logic
  const runInvestigation = useFollowupInvestigation({
    followupId,
    followup,
    content: _content,
    path,
    formActions,
    reduxEntity,
    notificationActions,
    pendingOperation: _pendingOperation,
    setIsRunning
  });
  const handleToggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom py-3"
  }, /*#__PURE__*/React.createElement(FollowupHeader, {
    followup: followup,
    isOpen: isOpen,
    onToggle: handleToggle,
    hasDetails: hasDetails
  }), hasDetails && /*#__PURE__*/React.createElement(FollowupDetails, {
    followup: followup,
    followupId: followupId,
    hasAnalysis: hasAnalysis,
    isOpen: isOpen,
    isRunning: isRunning,
    pendingOperation: _pendingOperation,
    onRunInvestigation: runInvestigation
  }));
};
FollowupCard.propTypes = {
  followupId: PropTypes.string.isRequired,
  followup: PropTypes.shape({
    query: PropTypes.string,
    description: PropTypes.string,
    priority: PropTypes.number,
    reasoning: PropTypes.string,
    analysis: PropTypes.shape({
      summary: PropTypes.string,
      execution: PropTypes.shape({
        rows: PropTypes.arrayOf(PropTypes.shape({})),
        success: PropTypes.bool,
        rowCount: PropTypes.number
      }),
      recommendations: PropTypes.string
    })
  }).isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  path: PropTypes.string.isRequired,
  formActions: PropTypes.shape({
    change: PropTypes.func.isRequired
  }).isRequired,
  reduxEntity: PropTypes.string.isRequired,
  pendingOperation: PropTypes.bool,
  notificationActions: PropTypes.shape({
    info: PropTypes.func.isRequired
  }).isRequired
};

// Removed defaultProps - using default parameters in function signature instead

export default FollowupCard;